import {spacing} from '../theme/theme'
import {css} from '../theme/css'

export const box = css`
  display: flex;
  align-items: center;
  background: linear-gradient(109.55deg, #21211f 39.36%, rgba(33, 32, 31, 0.4) 63.27%, #21211f 85.85%);
  margin-inline-start: ${spacing(0.5)};
  border-radius: ${spacing(12)};
  padding: ${spacing(0.2, 0.5)};
`
